import React, { ReactNode } from 'react';

import { styled } from '@mui/material/styles';

const IconWithCaption = ({
  icon,
  caption,
  correct,
  className = '',
}: {
  icon: ReactNode;
  caption: string;
  correct?: boolean;
  className?: string;
}) => (
  <IconWrapper className={className} data-testid={correct ? 'correctAnswer' : 'incorrectAnswer'}>
    {icon}
    <IconCaption isGreen={correct}>{caption}</IconCaption>
  </IconWrapper>
);

export default IconWithCaption;

const IconWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
`;
const IconCaption = styled('span', {
  shouldForwardProp: (prop) => prop !== 'isGreen',
})<{ isGreen?: boolean }>`
  display: block;
  color: ${({ isGreen, theme }) =>
    isGreen ? theme.palette.common.green : theme.palette.common.status.error};
  font-size: 10px;
`;
